import * as Sentry from '@sentry/browser';
import React from 'react';

interface State {
  hasError: boolean;
}

enum ErrorBoundaryTestID {
  Wrapper = 'ErrorBoundaryTestID.Wrapper',
}

export class ErrorBoundary extends React.Component {
  public state: State = { hasError: false };

  public static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  public componentDidCatch(error: Error): void {
    Sentry.captureException(error);
  }

  public render(): JSX.Element | React.ReactNode {
    if (this.state.hasError) {
      return (
        <div className="mt-12 flex flex-col items-center" data-testid={ErrorBoundaryTestID.Wrapper}>
          <img src={require('../assets/images/robot.png')} alt="error-page" />

          <h3 className="mt-10 text-gray-900 font-extrabold text-2xl">
            Oops! Well, this is unexpected
          </h3>

          <p className="mt-6 text-gray-900 font-medium text-lg">
            It looks like we’re experiencing an error.
          </p>
          <p className="mt.5 text-gray-900 font-medium text-lg">
            Try refreshing the page to see if this can be resolved
          </p>

          <p className="mt-6 text-gray-900 font-medium text-lg">
            If you’re still encountering issues, message us at
          </p>
          <a
            href="mailto:provider@joinmodernhealth.com"
            className="text-blue-200 font-medium text-lg"
          >
            provider@joinmodernhealth.com
          </a>

          <p className="mt-6 text-gray-900 font-medium text-lg">Thank you for your patience!</p>
        </div>
      );
    }

    return this.props.children;
  }
}
